const CAR_FUEL_TYPE = ['Diesel', 'Hybrid', 'EV', 'Petrol', 'Gasoline', 'Other'];

export default CAR_FUEL_TYPE;
